import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../productPageStyle.js";
import SectionHead from "./SectionHead.js";

const useStyles = makeStyles(styles);

export default function DescriptionSection({ t, product, num }) {
  const classes = useStyles();
  if (!product.description) return null;

  return (
    <section id="section-description" className={classes.section}>
      <SectionHead num={num} title={t.descTitle} />
      <div className={classes.sectionBody}>
        <p className={classes.paragraph}>{product.description}</p>
      </div>
    </section>
  );
}
